<template>
	<div class="page-in">
		<van-nav-bar :title="$t('我的收藏')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="layui-container">
					<div class="cart-main" v-if="goodsData && goodsData.length > 0">
						<div class="fav-title">{{$t('全部商品')}}({{goodsData.length}})</div>
						<div class="box-action flex">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
								@change="handleCheckAllChange">{{$t('全选')}}</el-checkbox>
							<el-button class="del-button" size="small" round @click="delAllFav">{{$t('删除')}}</el-button>
						</div>
						<div class="goods-table">
							<el-checkbox-group v-model="checkedArray" @change="handleCheckedChange">
								<div class="goods-cell" v-for="(item,index) in goodsData" :key="index">
									<div class="goods-cell__row">
										<el-checkbox :label="item.id"></el-checkbox>
										<div class="goods-cell-photo" @click="getProductGetUrl(item.goods_id)">
											<img :src="item.img" alt="" />
										</div>
										<div class="flex-col">
											<div class="goods-title ellipsis" @click="getProductGetUrl(item.goods_id)">{{item.title}}</div>
											<div class="goods-price text-primary">{{formatNumber(item.price)}}VND</div>
											<div class="goods-item">{{item.sell_count}}+{{$t('人付款')}}</div>
										</div>
									</div>
									<div class="goods-cell-action">
										<el-link class="del-el-link"
											@click.native="delFavorites(item.id)">{{$t('删除')}}</el-link>
										<!-- <el-button class="add-button" type="warning" round @click="addCart(item)">{{$t('加入购物袋')}}</el-button> -->
									</div>
								</div>
							</el-checkbox-group>
						</div>
					</div>
					<empty v-else />
			</div>
		</div>
	</div>
</template>
<script>
	import helper from '@/common/helper.js';
	import empty from "@/components/empty.vue"
	import {
		user_favorites_list_api,
		user_del_favorites_api,
		goods_addCart_api
	} from "@/api/user"
	export default {
		components: {
			empty
		},
		data() {
			return {
				checkAll: false,
				checkedArray: [],
				goodsData: null,
				isIndeterminate: false,
				ids:""
			};
		},
		methods: {
			handleCheckAllChange(val) {
				this.checkedArray = val ? this.goodsData.map(item => item.id) : [];
				this.isIndeterminate = false;
				console.log(val)
			},
			handleCheckedChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.goodsData.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.goodsData.length;
				console.log(value)
			},
			async getGoodsFavorites() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await user_favorites_list_api().then(res => {
					if (res && res.data.code == 1) {
						this.goodsData = res.data.data
					} 
					else if(res && res.data.code == -1){
						this.goLogin()
					}
					loading.close()
				});
			},
			delAllFav() {
				this.delFavorites(this.checkedArray)
			},
			getProductGetUrl(gid) {
				this.$router.push({
					path: '/product-detail',
					query: {
						id: gid
					}
				});
			},
			async addCart(item) {
				if(!this.$store.state.isLoginStatu){
					this.goUrl('/login')
					return false
				}
				this.$store.commit("$vuexSetAddCart", true);
				let param = {
					id: item.goods_id,
					num: 1,
					sku: ''
				}
				this.loading = true
				await goods_addCart_api(param).then(res => {
					console.log(res.data)
					if (res && res.data.code == 1) {
						this.$store.commit("$vuexSetAddCart", false);
						this.successTips('成功加入购物车');
						this.loading = false
						this.updateCart();
					} 
					else {
						this.errorTips(res.data.msg);
						this.loading = false
					}
				});
			},
			async delFavorites(ids) {
				this.ids = ids
				let data = {
					id: this.ids.toString(),
				};
				console.log(data)
				await user_del_favorites_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.successTips('删除成功')
						this.getGoodsFavorites()
					}else{
						this.errorTips(res.data.msg)
					}
				});
			},
		},
		mounted() {
			this.getGoodsFavorites()
			this.isCheckLogin()
		}
	};
</script>
<style scoped>
	.goods-cell-action{
		display: flex;
		align-items:flex-end;
		flex-direction: column;
	}
	@media (max-width:992px) {
		.page-in {
			background-color: #fafafa;
		}

		.goods-cell {
			border: 0;
			padding: 15px;
			background: #FFFFFF;
			margin-bottom: 10px;
			box-shadow: 0px 4px 7px 0px rgba(152, 152, 152, 0.09);
		}

		.goods-cell__row {
			padding: 0;
			margin-bottom: 10px;
		}

		.goods-cell .goods-item {
			font-size: 13px;
		}

		.goods-cell .goods-price,
		.goods-cell .goods-title {
			font-size: 16px;
			margin-bottom: 5px;
		}

		.goods-cell-photo {
			margin-right: 10px;
		}

		.goods-cell-photo img {
			width: 80px;
			height: 80px;
		}

		.goods-cell-action {
			right: 10px;
			top: 10px;
			padding: 5px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-direction: row;
		}

		.goods-cell-action .del-el-link {
			margin-bottom: 0;
		}

		.goods-cell-action .add-button {
			width: 160px;
		}
	}
</style>